import domReady from '@wordpress/dom-ready';
import { createRoot, render, useState } from '@wordpress/element';
import Slider from 'react-slick';

const App = ( { attributes } ) => {
	const { 
		slidesDotsShow,
		slidesAutoplay,
		infiniteLoop,
		transitionSpeed,
		autoplaySpeed,
		draggable,
		popupVideos,
		enableImage,
		enableVideo
	} = attributes;

	const settings = {
		dots: slidesDotsShow,
		arrows: false,
		slidesToShow: 1,
		autoplay: slidesAutoplay,
		slidesToScroll: 1,
		draggable: draggable,
		accessibility: false,
		autoplaySpeed: autoplaySpeed,
		infinite: infiniteLoop,
		speed: transitionSpeed,
		pauseOnHover: false,
		responsive: [
			{
			  breakpoint: 1024,
			  settings: {
				slidesToShow: 1,
				slidesToScroll: 1,
				initialSlide: 1
			  }
			},
			{
			  breakpoint: 480,
			  settings: {
				slidesToShow: 1,
				slidesToScroll: 1
			  }
			}
		]
		
	};

	const [isOpen, setOpen] = useState(false);

	const closeModal = () => {
		setOpen(false);
	};

	return (
		
			<Slider { ...settings }>
				{ popupVideos?.map( ( video, index  ) => (
					<div className="flywp-blocks-video-slider-item" key={index}>
						{
							enableImage && (
								video.videoThumb.url && (
									<div className='video-image'>
										<img src={video.videoThumb.url} atl={video.videoThumb.title} />
									</div>
								)
								
							)
						}
						
						{
							enableVideo && (
								video.videoUrl && (
									<div className="flywp-video">
										<iframe
											src={ video.videoUrl }
											frameBorder="0"
											allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
											allowfullscreen
											loading="lazy"
										></iframe>
									</div>
								)
								
							)
						}
						
					</div>
				) ) }
				
			</Slider>
	);
};

domReady( () => {
	const elements = document.querySelectorAll(
		'.wp-block-flywp-blocks-video-popup-slider'
	);
	const elementsArr = Array.from( elements );

	elementsArr.forEach( ( item ) => {
		if ( createRoot ) {
			createRoot( item ).render(
				<App
					attributes={ JSON.parse(
						item.getAttribute( 'data-block-attributes' )
					) }
				/>
			);
		} else {
			render(
				<App
					attributes={ JSON.parse(
						item.getAttribute( 'data-block-attributes' )
					) }
				/>,
				item
			);
		}
	} );

} );